import { MainLayout } from "../../design-system/Templates";
import { Footer } from "@/design-system/Organisms";
import { SelfScheduleTemplate } from "@/design-system/Templates";

const SelfSchedule = () => {
  return (
    <MainLayout
      header={null}
      sidebar={null}
      className=""
      footer={<Footer config={{ showTopSection: false }} />}
      topBanner={null}
    >
      <SelfScheduleTemplate />
    </MainLayout>
  );
};

export default SelfSchedule;
